import React, { Component, createRef, useEffect } from 'react';
import PageTitle from "../../../Components/PageTitle";
import { SubmitBtn, SubmitButton } from "../../../Components/InputElements";
import axios from 'axios';
import Swal from 'sweetalert2';
import Select from 'react-select';
import withRouter from '../../../Utils/withRouter';
import { ConfigContext } from '../../../Context/ConfigContext'
import { currentDateAndTime, getNextMonthBeforeDate, isNumeric, isNumericTill12, isNumericTill31, isNumericTillGivenNumber, isNumericWithDot, isValidAttendanceCycle } from '../../../Constants/constants';
import { decodeData } from '../../../Constants/constants';
import TooltipComponent from '../../../Components/TooltipComponent';
import { isNullOrUndefined } from 'util';
class GeneralSettings extends Component {
    static contextType = ConfigContext;
    constructor(props) {
        super(props);
        this.state = {
            attendance_setting_id: 0,
            attendance_month_cycle: "1",
            attendance_month_cycle_from_date: "01",
            attendance_month_cycle_to_date: "",
            company_location_shift_id: 0,
            location_restriction: "0",
            location_distance_restriction: "0",
            multiple_punch_allowed: "0",
            allowed_punch_per_day: "",
            how_multi_punch_record: "",
            late_auto_regularize: "0",
            clear_late_early_marks: "0",
            clear_late_early_marks_time: "",
            auto_regularize_checkin: "0",
            auto_regularize_checkout: "0",
            mode_of_attendance: "",
            late_coming_limit: "",
            early_going_limit: "",
            early_going_allowed_minute: "0",
            late_allowed_minutes: "0",
            excluded_grace_period_checkout: "",
            grace_period_late: "",
            grace_period_early: "",
            minimum_hours_for_half_day: "",
            preceding_succeeding_min_hours: "0",
            late_coming_exceeding_policy: "",
            early_going_exceeding_policy: "",
            excluded_grace_period_status_checkin: "0",
            excluded_grace_period_status_checkout: "0",
            excluded_grace_period_checkin: "",
            exclude_weekly_off: "0",
            exclude_holiday: "0",
            shift_rows: [],
            loadingList: false,
            postLoading: false,
            errors: {},
            decodedData: [],
            latemark_exceeds_allowed: "3",
            latemark_exceed: "", 
            absentDaysTreated: "", 
            absentHierarchy: [], 
            leaveOptions: [], 
            loading: true, 
            selectedLeaveType: '',
            restrict_longitude_latitude: "0",
            latitude: "",
            longitude: "",
            distance: "",
            is_flexi_shift: 0,
            flexi_shift_min_hour_for_half_day: "",
            flexi_shift_min_hour_for_full_day: "",
            flexi_shift_what_to_consider_extra_hour_in_day: "3",
            flexi_shift_max_hour_for_day: "",
        };
        this.minimum_hours_for_half_dayRef = createRef();
        this.allowed_punch_per_dayRef = createRef();
        this.how_multi_punch_recordRef = createRef();
        this.attendance_month_cycleRef = createRef();
        this.attendance_month_cycle_from_dateRef = createRef();
        this.multiple_punch_allowedRef = createRef();
        this.clear_late_early_marksRef = createRef();
        this.clear_late_early_marks_timeRef = createRef();
        this.latemark_exceeds_allowedRef = createRef();
        
    }
    componentDidMount() {
        this.setState({ loadingList: true }, (prevState) => {
            this.GetShiftList();
            // this.GetAttendanceSettingInfo();
        });
    }
    handleMainOptionChange = (option) => {
        this.setState({
            latemark_exceeds_allowed: option, 
            // latemark_exceed: "", 
            // absentHierarchy: [], 
            errors:{
                ...this.state.errors,
                latemark_exceeds_allowed:'',
            }
        });
    };
    handleLOPChange = (option) => {
        this.setState({ 
            latemark_exceed: option,
            errors:{
                ...this.state.errors,
                latemark_exceed:'',
            }
         });
    };
    // handleHierchy = (id) => {

    //     this.setState((prevState) => ({
    //         absentHierarchy: [...prevState.absentHierarchy, id],
    //     }));
    // };

    handleHierchy = (id) => {
        // console.log("leave type id", id, typeof id);
        this.setState((prevState) => {

            const leaveObject = this.state.leaveOptions.find(option => option.leave_type_id == id);
            // console.log("leaveObject",leaveObject);
            if (leaveObject && !prevState.absentHierarchy.some(item => item.leave_type_id == id)) {
                // console.log("leaveObject",leaveObject)
                return {
                    absentHierarchy: [...prevState.absentHierarchy, leaveObject],
                    errors:{
                        ...this.state.errors,
                        absentHierarchy:"",
                    }
                };
            }
        
            return null;
        });
    };

    // handleRemoveAbsentHierarchy = (value) => {
    //     this.setState((prevState) => {
    //         const updatedHierarchy = prevState.absentHierarchy.filter((item) => item !== value);
    //         return { absentHierarchy: updatedHierarchy };
    //     }, () => console.log("Updated absentHierarchy:", this.state.absentHierarchy));
    // };
    handleRemoveAbsentHierarchy = (id) => {
        this.setState((prevState) => {
            // Filter out the object where leave_type_id matches the given id
            const updatedHierarchy = prevState.absentHierarchy.filter(item => item.leave_type_id !== id);
            
            return { absentHierarchy: updatedHierarchy };
        });
    };
    
    // handleHierchy = (leave_type_id) => {
    //     this.setState((prevState) => {
            
    //         if (!prevState.absentHierarchy.includes(leave_type_id)) {
               
    //             return { 
    //                 absentHierarchy: [...prevState.absentHierarchy, leave_type_id], 
    //                 selectedLeaveType: leave_type_id  
    //             };
    //         }
    //         return prevState;
    //     });
    // };
    
    
    // handleRemoveAbsentHierarchy = (value) => {
    //     this.setState((prevState) => ({
    //         absentHierarchy: prevState.absentHierarchy.filter((item) => item !== value),
    //     }));
    // };
    
    // handleRemoveAbsentHierarchy = (value) => {
    //     this.setState((prevState) => {
    //         const updatedHierarchy = prevState.absentHierarchy.filter((item) => item !== leave_type_id);
    //         return { absentHierarchy: updatedHierarchy };
    //     }, () => console.log("Updated absentHierarchy:", this.state.absentHierarchy));
    // };

   
    
    handleLeaveTypeChange = (event) => {
        this.setState({ selectedLeaveType: event.target.value });
      };
    
    componentDidUpdate(prevProps, prevState) {
        if (prevState.permissions !== this.context.permissions) {
          // console.log("Permissions Updated:", this.context.permissions);
            const { permissions } = this.context;
            if (permissions.length > 0) {
              const queryParams = new URLSearchParams(window.location.search);
              const encodedData = queryParams.get("abs");
              const decodedData = encodedData ? decodeData(encodedData, permissions) : [0];
              if (JSON.stringify(prevState.decodedData) !== JSON.stringify(decodedData)) {
                this.setState({ decodedData });
              }
            } else {
              console.warn("Permissions not yet available. Retrying...");
            }
        }
        if (this.state.errors.minimum_hours_for_half_day && prevState.errors.minimum_hours_for_half_day !== this.state.errors.minimum_hours_for_half_day && this.minimum_hours_for_half_dayRef.current) {
            this.minimum_hours_for_half_dayRef.current.scrollIntoView({ behavior: 'smooth', block: 'center' });
            this.minimum_hours_for_half_dayRef.current.focus();
        }
        if (this.state.errors.attendance_month_cycle && prevState.errors.attendance_month_cycle !== this.state.errors.attendance_month_cycle && this.attendance_month_cycleRef.current) {
            this.attendance_month_cycleRef.current.scrollIntoView({ behavior: 'smooth', block: 'center' });
            this.attendance_month_cycleRef.current.focus();
        }
        if (this.state.errors.attendance_month_cycle_from_date && prevState.errors.attendance_month_cycle_from_date !== this.state.errors.attendance_month_cycle_from_date && this.attendance_month_cycle_from_dateRef.current) {
            this.attendance_month_cycle_from_dateRef.current.scrollIntoView({ behavior: 'smooth', block: 'center' });
            this.attendance_month_cycle_from_dateRef.current.focus();
        }
        if (this.state.errors.multiple_punch_allowed && prevState.errors.multiple_punch_allowed !== this.state.errors.multiple_punch_allowed && this.multiple_punch_allowedRef.current) {
            this.multiple_punch_allowedRef.current.scrollIntoView({ behavior: 'smooth', block: 'center' });
            this.multiple_punch_allowedRef.current.focus();
        }
        if (this.state.errors.allowed_punch_per_day && prevState.errors.allowed_punch_per_day !== this.state.errors.allowed_punch_per_day && this.allowed_punch_per_dayRef.current) {
            this.allowed_punch_per_dayRef.current.scrollIntoView({ behavior: 'smooth', block: 'center' });
            this.allowed_punch_per_dayRef.current.focus();
        }
        if (this.state.errors.how_multi_punch_record && prevState.errors.how_multi_punch_record !== this.state.errors.how_multi_punch_record && this.how_multi_punch_recordRef.current) {
            this.how_multi_punch_recordRef.current.scrollIntoView({ behavior: 'smooth', block: 'center' });
            this.how_multi_punch_recordRef.current.focus();
        }
        if (this.state.errors.clear_late_early_marks && prevState.errors.clear_late_early_marks !== this.state.errors.clear_late_early_marks && this.clear_late_early_marksRef.current) {
            this.clear_late_early_marksRef.current.scrollIntoView({ behavior: 'smooth', block: 'center' });
            this.clear_late_early_marksRef.current.focus();
        }
        if (this.state.errors.clear_late_early_marks_time && prevState.errors.clear_late_early_marks_time !== this.state.errors.clear_late_early_marks_time && this.clear_late_early_marks_timeRef.current) {
            this.clear_late_early_marks_timeRef.current.scrollIntoView({ behavior: 'smooth', block: 'center' });
            this.clear_late_early_marks_timeRef.current.focus();
        }
        



        if (this.state.errors.latemark_exceeds_allowed && prevState.errors.latemark_exceeds_allowed !== this.state.errors.latemark_exceeds_allowed && this.latemark_exceeds_allowedRef.current) {
            this.latemark_exceeds_allowedRef.current.scrollIntoView({ behavior: 'smooth', block: 'center' });
            this.latemark_exceeds_allowedRef.current.focus();
        }
      }
    handleInputChange = (e) => {
        const { name, value } = e.target;

        this.setState((prevState) => ({
            [name]: value,
            errors: {
                ...prevState.errors,
                [name]: '',
            },
        }));
    };
    handleNumberOnlyChange = (e) => {
        const { name, value } = e.target;
        if (isNumeric(value) || value === "") {
            this.setState((prevState) => ({
                [name]: value,
                errors: {
                    ...prevState.errors,
                    [name]: '',
                },
            }));
        }
    }

    handleNumberDecimalMinusOnlyChange = (e) => {
        const { name, value } = e.target;
    
    
        const validNumberRegex = /^-?\d*\.?\d*$/;
    
        if (validNumberRegex.test(value) || value === "") {
            this.setState((prevState) => ({
                [name]: value,
                errors: {
                    ...prevState.errors,
                    [name]: '',
                },
            }));
        }
    };
    handleDistanceChange = (e) => {
        const { name, value } = e.target;
    
        // Regular expression to allow only positive numbers with optional decimals
        const validNumberRegex = /^\d*\.?\d*$/;
    
        if (validNumberRegex.test(value) || value === "") {
            if (value === "" || parseFloat(value) >= 1) {
                this.setState((prevState) => ({
                    [name]: value,
                    errors: {
                        ...prevState.errors,
                        [name]: '',
                    },
                }));
            } 
            
        }
    };
    
    
    handleNumberOnlyTill31Change = (e) => {
        const { name, value } = e.target;
        if (isNumericTill31(value) || value === "") {
            this.setState((prevState) => ({
                [name]: value,
                errors: {
                    ...prevState.errors,
                    [name]: '',
                },
            }));
        }
    }
    handleNumberChange = (e, num) => {
        const { name, value } = e.target;
        if (isNumericTillGivenNumber(value, num) || value === "") {
            let date = `${new Date()?.getFullYear()}-${new Date()?.getMonth()}-${value}`;
            // console.log("handleNumberChange ~ date", date);
            date = getNextMonthBeforeDate(date);
            let nextDay = date?.split("-")[2];
            this.setState((prevState) => ({
                [name]: value,
                attendance_month_cycle_to_date: nextDay || "",
                errors: {
                    ...prevState.errors,
                    [name]: '',
                },
            }));
        }
    }
    getToData = (name,value) => {
        if(name === "attendance_month_cycle_from_date"){
            let date = `${currentDateAndTime()?.split(" ")[0]?.split("-")?.[0]}-${currentDateAndTime()?.split(" ")[0]?.split("-")?.[1]}-${value}`;
            date = getNextMonthBeforeDate(date);
            
            let nextDay = date?.split("-")[2];
            // console.log("handleMonthCycleDate, nextDay",date, value, nextDay);
            return nextDay;
        }
        return
    }
    handleMonthCycleDate = (name, value) => {
        if(name === "attendance_month_cycle_from_date"){
            let date = `${currentDateAndTime()?.split(" ")[0]?.split("-")?.[0]}-${currentDateAndTime()?.split(" ")[0]?.split("-")?.[1]}-${value}`;
            date = getNextMonthBeforeDate(date);
            
            let nextDay = date?.split("-")[2];
            // console.log("handleMonthCycleDate, nextDay",date, value, nextDay);
            this.setState((prevState) => ({
                [name]: value,
                attendance_month_cycle_to_date: nextDay || "",
                errors: {
                    ...prevState.errors,
                    [name]: '',
                },
            }));
        }
        else{
            this.setState((prevState) => ({
                [name]: value,
                errors: {
                    ...prevState.errors,
                    [name]: '',
                },
            }));
        }
    }
    handleNumberWithDotChange = (e) => {
        const { name, value } = e.target;
        if (isNumericWithDot(value)) {
            // console.log("value 1", value);
            if (value?.includes(".")) {
                let beforeDot = parseInt(value?.split(".")[0]);
                let afterDot = parseInt(value?.split(".")[1]);
                // console.log("value 2", value, "beforeDot", beforeDot, "afterDot", afterDot);
                if (beforeDot < 24 && afterDot <= 60) {
                    this.setState((prevState) => ({
                        [name]: value,
                        errors: {
                            ...prevState.errors,
                            [name]: '',
                        },
                    }));
                }
                else if (beforeDot < 24 && afterDot === NaN || !afterDot) {
                    // console.log("value 2.1", value, "beforeDot", beforeDot);
                    this.setState((prevState) => ({
                        [name]: value,
                        errors: {
                            ...prevState.errors,
                            [name]: '',
                        },
                    }));
                }
            }
            else {
                let num = parseInt(value);
                // console.log("value 3", value, '~', num);
                if (num <= 24 || value === "") {
                    // console.log("name", name);
                    // console.log("value", value);
                    this.setState((prevState) => ({
                        [name]: value,
                        errors: {
                            ...prevState.errors,
                            [name]: '',
                        },
                    }));
                }
            }

        }
    }
    GetShiftList = () => {
        const { apiURL, apiHeaderJSON } = this.context;
        const headers = apiHeaderJSON;
        axios.get(`${apiURL}Masters/GetShiftList`, { headers })
            .then((response) => {
                var data = response.data.data;
                if (response.data.success === true) {
                    this.setState((prevState) => ({
                        shift_rows: data.map((row) => ({
                            value: row.company_location_shift_id,
                            label: row.company_location_shift_name,
                        }))
                    }));
                }
            });
    }

    GetAttendanceSettingInfo = () => {
        const { apiURL, apiHeaderJSON } = this.context;
        const headers = apiHeaderJSON;

        axios.get(`${apiURL}Attendance/GetAttendanceSettingInfo`, {
            params:{
                company_location_shift_id: this.state.company_location_shift_id || null,
            }, 
            headers }).then((response) => {
            const { data, success } = response.data;
            // console.log('GetAttendanceSettingInfo ~ response', response);
            if (success === true) {
                console.log("data[0]",data[0]);
                console.log("data[0]?.is_flexi_shift",data[0]?.is_flexi_shift);
                this.setState(
                    {
                        attendance_setting_id: data[0]?.attendance_setting_id,
                        attendance_month_cycle: data[0]?.attendance_month_cycle || "1",
                        attendance_month_cycle_from_date: data[0]?.attendance_month_cycle_start_date || "01",
                        attendance_month_cycle_to_date: data[0]?.attendance_month_cycle_end_date || this.getToData("attendance_month_cycle_from_date", "01"),
                        multiple_punch_allowed: data[0]?.multiple_punch_allowed || "0",
                        allowed_punch_per_day: data[0]?.allowed_punch_per_day || "",
                        how_multi_punch_record: data[0]?.how_multi_punch_record || "",
                        mode_of_attendance: data[0]?.mode_of_attendance,
                        late_coming_limit: data[0]?.late_coming_limit,
                        early_going_limit: data[0]?.early_going_limit,
                        early_going_allowed_minute: data[0]?.early_going_allowed_minute,
                        late_allowed_minutes: data[0]?.late_allowed_minutes,
                        grace_period_late: data[0]?.grace_period_late,
                        excluded_grace_period_checkout: data[0]?.excluded_grace_period_checkout,
                        grace_period_early: data[0]?.grace_period_early,
                        minimum_hours_for_half_day: data[0]?.minimum_hours_for_half_day,
                        preceding_succeeding_min_hours: data[0]?.preceding_succeeding_min_hours,
                        late_coming_exceeding_policy: data[0]?.late_coming_exceeding_policy,
                        early_going_exceeding_policy: data[0]?.early_going_exceeding_policy,
                        clear_late_early_marks: data[0]?.clear_late_early_marks?.toString(),
                        clear_late_early_marks_time: data[0]?.clear_late_early_marks_time,
                        excluded_grace_period_status_checkin: data[0]?.excluded_grace_period_status_checkin,
                        excluded_grace_period_status_checkout: data[0]?.excluded_grace_period_status_checkout,
                        excluded_grace_period_checkin: data[0]?.excluded_grace_period_checkin,
                        location_restriction: data[0]?.location_restriction,
                        auto_regularize_checkin: data[0]?.auto_regularize_checkin,
                        auto_regularize_checkout: data[0]?.auto_regularize_checkout,
                        location_distance_restriction: data[0]?.location_distance_restriction,
                        exclude_weekly_off: data[0]?.exclude_weekly_off,
                        exclude_holiday: data[0]?.exclude_holiday,
                        latemark_exceeds_allowed: data[0]?.what_to_do_with_last_occasion || null,
                        latemark_exceed: data[0]?.mark_lop_type || data[0]?.leave_deduction_type ||null,
                        absentHierarchy: data[0]?.leave_deduction_hierarchy_info || [],
                        restrict_longitude_latitude: data[0]?.restrict_longitude_latitude || "0",
                        latitude: data[0]?.latitude || "",
                        longitude:data[0]?.longitude || "",
                        distance: data[0]?.distance || "",
                        is_flexi_shift: data[0]?.is_flexi_shift || 0,
                        flexi_shift_min_hour_for_half_day: data[0]?.flexi_shift_min_hour_for_half_day || "",
                        flexi_shift_min_hour_for_full_day: data[0]?.flexi_shift_min_hour_for_full_day || "",
                        flexi_shift_what_to_consider_extra_hour_in_day: data[0]?.flexi_shift_what_to_consider_extra_hour_in_day || 0,
                        flexi_shift_max_hour_for_day: data[0]?.flexi_shift_max_hour_for_day || "",

                    }, ()=>{
                        console.log("this.state.is_flexi_shift",this.state.is_flexi_shift);
                    }
                );
            }
            else{
                this.setState(
                    {
                        attendance_setting_id: "",
                        attendance_month_cycle: "",
                        attendance_month_cycle_from_date: "",
                        attendance_month_cycle_to_date: "",
                        multiple_punch_allowed: "0",
                        allowed_punch_per_day : "",
                        how_multi_punch_record: "",
                        mode_of_attendance: "",
                        late_coming_limit: "",
                        early_going_limit: "",
                        early_going_allowed_minute: "",
                        late_allowed_minutes: "",
                        grace_period_late: "",
                        excluded_grace_period_checkout: "",
                        grace_period_early: "",
                        minimum_hours_for_half_day: "",
                        preceding_succeeding_min_hours: "",
                        late_coming_exceeding_policy: "",
                        early_going_exceeding_policy: "",
                        clear_late_early_marks: "",
                        clear_late_early_marks_time: "",
                        excluded_grace_period_status_checkin: "",
                        excluded_grace_period_status_checkout: "",
                        excluded_grace_period_checkin: "",
                        location_restriction: "",
                        auto_regularize_checkin: "",
                        auto_regularize_checkout: "",
                        location_distance_restriction: "",
                        exclude_weekly_off: "",
                        exclude_holiday: "",
                        latemark_exceeds_allowed: "3",
                        latemark_exceed: null,
                        absentHierarchy: [],
                        restrict_longitude_latitude: "0",
                        latitude:"",
                        longitude:"",
                        distance:"",

                    }
                )
            }
        });
    }

    GetList = () => {
        const { apiURL, apiHeaderJSON } = this.context;
        const headers = apiHeaderJSON;
       
        axios.get(`${apiURL}Masters/GetLeaveTypesSandbox`, { params: { limit: 9999, page: 1 }, headers }).then((response) => {
            var data = response.data;
            if (response.data.success === true) {
                const uniqueLeaveOptions = Array.from(
                    new Set(data.data.map((item) => item.leave_type_name))
                ).map((leave_type_name) => 
                    data.data.find((item) => item.leave_type_name === leave_type_name)
                );
                this.setState({
                    rows: data.data,
                    next: data.next,
                    prev: data.prev,
                    page: data.page,
                    total_records: data.total_records,
                    total_pages: data.total_pages,
                    loadingList: false,
                    // leaveOptions: response.data.data,
                    leaveOptions: uniqueLeaveOptions,
                    loading: false,
                   
                });
                
                // console.log("leaveOptions ====>",uniqueLeaveOptions)
                // console.log("data.lenghth", data.data.length);
                // console.log("this.state.leaveOptions===>",this.state.leaveOptions)
            } else {
                this.setState({ loadingList: false });
            }
        });
    }

    handleSubmit = (e) => {
        e.preventDefault();
        const errors = this.validateForm();
        console.log("errors", errors);
        if (Object.keys(errors).length > 0) {
            this.setState({ errors });
            return;
        }

        const leaveTypeIdsString = this.state.absentHierarchy
        ?.map(val => val?.leave_type_id).join(",");

        // console.log("leaveTypeIdsString",leaveTypeIdsString);

        this.setState({ postLoading: true });
        const { apiURL, apiHeaderJSON } = this.context;
        const headers = apiHeaderJSON;
        const formData = {
            company_location_shift_id: this.state.company_location_shift_id || null,
            attendance_setting_id: this.state.attendance_setting_id || null,
            attendance_month_cycle: this.state.attendance_month_cycle || "1",
            attendance_month_cycle_from_date: this.state.attendance_month_cycle_from_date || "01",
            attendance_month_cycle_to_date: this.state.attendance_month_cycle_to_date,
            multiple_punch_allowed: this.state.multiple_punch_allowed || "0",
            restrict_longitude_latitude: this.state.restrict_longitude_latitude || "0",
            latitude: this.state.latitude || "",
            longitude: this.state.longitude || "",
            distance: this.state.distance || "",
            allowed_punch_per_day : this.state.allowed_punch_per_day ||  "",
            how_multi_punch_record: this.state.how_multi_punch_record || "",
            grace_period_late: this.state.grace_period_late,
            clear_late_early_marks: this.state.clear_late_early_marks,
            clear_late_early_marks_time: this.state.clear_late_early_marks === "0" ? "" : this.state.clear_late_early_marks_time,
            excluded_grace_period_checkout: this.state.excluded_grace_period_checkout,
            grace_period_early: this.state.grace_period_early,
            late_coming_limit: this.state.late_coming_limit,
            early_going_limit: this.state.early_going_limit,
            late_allowed_minutes: this.state.late_allowed_minutes,
            early_going_allowed_minute: this.state.early_going_allowed_minute,
            minimum_hours_for_half_day: this.state.minimum_hours_for_half_day,
            preceding_succeeding_min_hours: this.state.preceding_succeeding_min_hours,
            late_coming_exceeding_policy: this.state.late_coming_exceeding_policy,
            early_going_exceeding_policy: this.state.early_going_exceeding_policy,
            excluded_grace_period_status_checkin: this.state.excluded_grace_period_status_checkin,
            excluded_grace_period_status_checkout: this.state.excluded_grace_period_status_checkout,
            excluded_grace_period_checkin: this.state.excluded_grace_period_checkin,
            location_restriction: this.state.location_restriction,
            auto_regularize_checkin: this.state.auto_regularize_checkin,
            auto_regularize_checkout: this.state.auto_regularize_checkout,
            location_distance_restriction: this.state.location_distance_restriction,
            exclude_weekly_off: this.state.exclude_weekly_off,
            exclude_holiday: this.state.exclude_holiday,
            mode_of_attendance: this.state.mode_of_attendance,
            date: currentDateAndTime(),
            leave_type_id: this.state.selectedLeaveType,  
            what_to_do_with_last_occasion: this.state.latemark_exceeds_allowed || null,
            mark_lop_type:  this.state.latemark_exceed || null,
            leave_deduction_type: this.state.latemark_exceed || null,
            leave_deduction_hierarchy: leaveTypeIdsString,
            is_flexi_shift: this.state.is_flexi_shift || 0,
            flexi_shift_min_hour_for_half_day: this.state.flexi_shift_min_hour_for_half_day || "",
            flexi_shift_min_hour_for_full_day: this.state.flexi_shift_min_hour_for_full_day || "",
            flexi_shift_what_to_consider_extra_hour_in_day: this.state.flexi_shift_what_to_consider_extra_hour_in_day || "",
            flexi_shift_max_hour_for_day: this.state.flexi_shift_max_hour_for_day || "",
        };
        console.log("UpdateAttendanceSetting formData =======>>>", formData);
        axios.post(`${apiURL}Attendance/UpdateAttendanceSetting`, formData, { headers })
        .then((response) => {
            const { success } = response.data;
            // console.log("response =======>>>", response);

            if (success === true) {
                
                // this.resetForm();
                Swal.fire({
                    title: `<strong>${success ? 'Success' : 'Failed'}</strong>`,
                    text: response.data.message,
                    icon: success ? 'success' : 'error',
                    showConfirmButton: true,
                    allowOutsideClick: false
                }).then((result) => {
                    if (result.isConfirmed) {
                        // Optional: You can perform any action here after OK is clicked
                        this.setState({ loadingList: true, postLoading: false }, (prevState) => { });
                        this.GetAttendanceSettingInfo();  // Call your function after the alert is closed
                        this.GetList();
                    }
                });
            } else {
                Swal.fire({
                    title: `<strong>${success ? 'Success' : 'Failed'}</strong>`,
                    text: response.data.message,
                    icon: success ? 'success' : 'error',
                    showConfirmButton: true,
                    allowOutsideClick: false
                }).then((result) => {
                    if (result.isConfirmed) {
                        // Optional: Action after the OK button is clicked
                        this.setState({ loadingList: true, postLoading: false }, (prevState) => { });
                    }
                });
            }

        })
        .catch((error)=>{
            console.error(error);
            this.setState({loadingList: false, postLoading: false });
            Swal.fire({
                title: `<strong>Failed</strong>`,
                text: error,
                icon: 'error',
                showConfirmButton: true,
                allowOutsideClick: false
            })
        })
    };

    resetForm = () => {
        this.setState({
            attendance_setting_id: 0,
            attendance_month_cycle: "",
            attendance_month_cycle_from_date: "01",
            attendance_month_cycle_to_date: "",
            multiple_punch_allowed: "0",
            restrict_longitude_latitude: "0",
            latitude: "",
            longitude: "",
            distance: "",
            allowed_punch_per_day : "",
            how_multi_punch_record: "",
            company_location_shift_id: 0,
            grace_period_late: '',
            excluded_grace_period_checkout: '',
            grace_period_early: '',
            late_coming_limit: '',
            early_going_limit: '',
            late_allowed_minutes: '0',
            early_going_allowed_minute: '0',
            minimum_hours_for_half_day: '',
            preceding_succeeding_min_hours: '',
            late_coming_exceeding_policy: '',
            early_going_exceeding_policy: '',
            excluded_grace_period_status_checkin: '0',
            excluded_grace_period_status_checkout: '0',
            excluded_grace_period_checkin: '0',
            auto_regularize_checkin: '0',
            auto_regularize_checkout: '0',
            location_restriction: false,
            location_distance_restriction: '',
            exclude_weekly_off: '0',
            exclude_holiday: '0',
            mode_of_attendance: '',
            loadingList: false,
            postLoading: false,
            errors: {},
            is_flexi_shift: 0,
            flexi_shift_min_hour_for_half_day: "",
            flexi_shift_min_hour_for_full_day: "",
            flexi_shift_what_to_consider_extra_hour_in_day: "",
            flexi_shift_max_hour_for_day: "",
        });
    };

validateForm() {
        const errors = {};

        // if (!this.state.mode_of_attendance || this.state.mode_of_attendance === '') {
        //     errors.mode_of_attendance = 'Please select mode of data capture';
        // }
        if (!this.state.attendance_month_cycle) {
            errors.attendance_month_cycle = 'Month cycle is required';
        }
        if (this.state.attendance_month_cycle==="2" && !this.state.attendance_month_cycle_from_date) {
            errors.attendance_month_cycle_from_date = 'Month cycle from date cannot be empty';
        }
        // if (this.state.attendance_month_cycle==="2" && !this.state.attendance_month_cycle_to_date) {
        //     errors.attendance_month_cycle_to_date = 'Month cycle to date cannot be empty';
        // }
        if (this.state.attendance_month_cycle==="2" && 
            this.state.attendance_month_cycle_from_date && 
            this.state.attendance_month_cycle_to_date) {
                // console.log(isValidAttendanceCycle(this.state.attendance_month_cycle_from_date,this.state.attendance_month_cycle_to_date));
                const {isTrue, days}=isValidAttendanceCycle(this.state.attendance_month_cycle_from_date,this.state.attendance_month_cycle_to_date);
                if(!isTrue){
                    if(days < 2){
                        errors.attendance_month_cycle_to_date = 'Month cycle days cannot be less than 2';
                    }
                    else if(days >31){
                        errors.attendance_month_cycle_to_date = 'Month cycle days cannot be more than 31';
                    }
                }
            
        }

       
        if (!this.state.is_flexi_shift && this.state.is_flexi_shift !== 0) {
            errors.is_flexi_shift = 'This is required!';
        }
        
    if (this.state.is_flexi_shift=="1") {

        if(!this.state.flexi_shift_min_hour_for_half_day) {
            errors.flexi_shift_min_hour_for_half_day = 'This is required.';
        }
        if(!this.state.flexi_shift_min_hour_for_full_day) {
            errors.flexi_shift_min_hour_for_full_day = 'This is required.';
        }
        if(!this.state.flexi_shift_what_to_consider_extra_hour_in_day) {
            errors.flexi_shift_what_to_consider_extra_hour_in_day = 'This is required.';
        }
        if(!this.state.flexi_shift_max_hour_for_day) {
            errors.flexi_shift_max_hour_for_day = 'This is required.';
        }
    }
    if (this.state.is_flexi_shift=="0") {
        if (!this.state.minimum_hours_for_half_day) {
            errors.minimum_hours_for_half_day = 'Minimum hours for half day cannot be empty';
        }
        if (this.state.multiple_punch_allowed==="1" && !this.state.allowed_punch_per_day) {
            errors.allowed_punch_per_day = 'This is required.';
            return errors;
        }
        if (this.state.multiple_punch_allowed==="1" && !this.state.how_multi_punch_record) {
            errors.how_multi_punch_record = 'This is required.';
            return errors;
        }
        if (this.state.multiple_punch_allowed==="1" && this.state.allowed_punch_per_day) {
            const num = parseInt(this.state.allowed_punch_per_day);
            if(num > 5) errors.allowed_punch_per_day = 'Max 5 punch allowed!';
            return errors;
        }
        if (!this.state.clear_late_early_marks) {
            errors.clear_late_early_marks = ' This field cannot be empty';
            return errors;
        }
        if (this.state.clear_late_early_marks === "1" && !this.state.clear_late_early_marks_time) {
            errors.clear_late_early_marks_time = ' This field cannot be empty';
            return errors;
        }




        
        if(this.state.restrict_longitude_latitude === "1" && !this.state.restrict_longitude_latitude){
            errors.restrict_longitude_latitude = 'This is required.';
        }
        if(this.state.restrict_longitude_latitude === "1" && !this.state.latitude){
            errors.latitude = 'This is required. ';
        }
        if(this.state.restrict_longitude_latitude === "1" && !this.state.longitude){
            errors.longitude = 'This is required. ';
        }
        if(this.state.restrict_longitude_latitude === "1" && !this.state.distance){
            errors.distance = 'This is required. ';
        }
        
        

        // if (this.state.location_distance_restriction < 0 && this.state.location_restriction == 1) {
        //     errors.location_distance_restriction = 'Distance in Meters cannot be negative';
        // }

        if (this.state.grace_period_late < 0) {
            errors.grace_period_late = 'Grace period cannot be negative';
        }
        if (this.state.excluded_grace_period_checkin < 0) {
            errors.excluded_grace_period_checkin = 'Excluded grace period cannot be negative';
        }
        if (this.state.late_coming_limit < 0) {
            errors.late_coming_limit = ' Late mark in a month cannot be negative';
        }
        
        if (this.state.late_coming_limit > 31) {
            errors.late_coming_limit = ' Late mark in a month cannot be greater than 31';
        }
        if (this.state.late_coming_exceeding_policy < 0) {
            errors.late_coming_exceeding_policy = ' Late mark exceeds cannot be negative';
        }
        if (this.state.late_coming_exceeding_policy > 31) {
            errors.late_coming_exceeding_policy = ' Late mark Exceeds cannot be greater than 31';
        }


        if (this.state.grace_period_early < 0) {
            errors.grace_period_early = 'Grace period cannot be negative';
        }
        if (this.state.excluded_grace_period_checkout < 0) {
            errors.excluded_grace_period_checkout = 'Excluded grace period cannot be negative';
        }
        if (this.state.early_going_limit < 0) {
            errors.early_going_limit = 'Early mark in a month cannot be negative';
        }
        if (this.state.early_going_limit > 31) {
            errors.early_going_limit = 'Early mark in a month cannot be greater than 31';
        }
        if (this.state.early_going_exceeding_policy < 0) {
            errors.early_going_exceeding_policy = 'Early mark exceeds cannot be negative';
        }
        if (this.state.early_going_exceeding_policy > 31) {
            errors.early_going_exceeding_policy = 'Early mark Exceeds cannot be greater than 31';
        }
        if (!this.state.latemark_exceeds_allowed) {
            errors.latemark_exceeds_allowed = 'This is required!';
            return errors;
        }
        if ((this.state.latemark_exceeds_allowed==="1" || this.state.latemark_exceeds_allowed==="2") && !this.state.latemark_exceed) {
            errors.latemark_exceed = 'This is required!';
            if(this.state.latemark_exceeds_allowed==="2" && this.state.leaveOptions.length>0){
                errors.absentHierarchy= 'This is required!';
                return errors;
            }
            return errors;
        }
    }


        return errors;
    }

    handleRadioChange = (name, value) => {
        if (name === "attendance_month_cycle" && value === "1") {
            this.setState((prevState) => ({
                [name]: value,
                errors: {
                    ...prevState.errors,
                    [name]: '',
                },
            }));
        }
        else {
            this.setState((prevState) => ({
                [name]: value,
                errors: {
                    ...prevState.errors,
                    [name]: '',
                },
            }));
        }


    };
    handleSelect = (e) => {
        var ids = [];
        for (var i = 0; i < e.length; i++) {
            ids.push(e[i].value);
        }
        this.setState((prevState) => ({ mode_of_attendance: ids.join(','), errors: { ...prevState.errors, mode_of_attendance: '', } }))
    }

    handleSelectChange(name, selectedOption) {
        // console.log("name, selectedOption",name, selectedOption);
        this.setState((prevState) => ({ [name]: selectedOption.value,
            errors:{
                [name]: "",
            }
         }), () => {
            this.GetAttendanceSettingInfo();
            this.GetList();
        })
    }
    handleSelectChangeOptions(name, selectedOption) {
        // console.log("name, selectedOption",name, selectedOption);
        this.setState((prevState) => ({ [name]: selectedOption.value,
            errors:{
                [name]: "",
            }
         }));
    }


    render() {
        const { errors } = this.state;
        const DataCaptures = [
            { value: 'Bio Metric Attendance', label: 'Bio Metric Attendance' },
            { value: 'Web Log In', label: 'Web Log In' },
            { value: 'Mobile App Login', label: 'Mobile App Login' },
            { value: 'Excel Import', label: 'Excel Import' },
        ];
        // console.log("this.state.attendance_month_cycle_to_date render=>",this.state.attendance_month_cycle_to_date);
        // console.log("this.state.flexi_shift_min_hour_for_full_day render=>",this.state.flexi_shift_min_hour_for_full_day);
        const monthStartDates = [
            { value: 1, label: "01" },
            { value: 2, label: "02" },
            { value: 3, label: "03" },
            { value: 4, label: "04" },
            { value: 5, label: "05" },
            { value: 6, label: "06" },
            { value: 7, label: "07" },
            { value: 8, label: "08" },
            { value: 9, label: "09" },
            { value: 10, label: "10" },
            { value: 11, label: "11" },
            { value: 12, label: "12" },
            { value: 13, label: "13" },
            { value: 14, label: "14" },
            { value: 15, label: "15" },
            { value: 16, label: "16" },
            { value: 17, label: "17" },
            { value: 18, label: "18" },
            { value: 19, label: "19" },
            { value: 20, label: "20" },
            { value: 21, label: "21" },
            { value: 22, label: "22" },
            { value: 23, label: "23" },
            { value: 24, label: "24" },
            { value: 25, label: "25" },
            { value: 26, label: "26" },
            { value: 27, label: "27" },
            { value: 28, label: "28" },
            // { value: 29, label: "29" },
            // { value: 30, label: "30" },
            // { value: 31, label: "31" },
        ]
        const multi_punch_record_options=[
            { value: "1", label: "Without Geo Tagging" },
            { value: "2", label: "With Geo Tagging" },
        ]
        return (
            <div className="main-content">
                <div className="page-content">
                    <div className="container-fluid">
                        <br />
                        <PageTitle title={`General Settings`} primary={`Home`} />
                        <div className="row">
                            <div className="col-md-12">
                                <div className="card">
                                    <div className="card-header align-items-center d-flex">
                                        <h4 className="card-title mb-0 flex-grow-1">General Settings</h4>
                                    </div>
                                    <div className="card-body">
                                        <div className="row gy-4">
                                            <div className="col-md-12">
                                                <form onSubmit={this.handleSubmit} className="row settings-form">
                                                    {/* Select Shift */}
                                                    <div className="col-md-6 mt-3 settings-section">
                                                        <label>Select shift</label>
                                                        <Select
                                                            value={this.state.company_location_shift_id ? this.state.shift_rows.find(option => option.value === this.state.company_location_shift_id) : null}
                                                            onChange={(selectedOption) => this.handleSelectChange('company_location_shift_id', selectedOption)}
                                                            options={this.state.shift_rows}
                                                            placeholder="Select shift"
                                                        />
                                                    </div>
                                                    {/* Data Capture Settings */}
                                                    {/* <div className="col-md-6 mt-3 settings-section">
                                                        <label>Mode of data capture</label>
                                                        <Select
                                                            onChange={this.handleSelect}
                                                            isDisabled={!this.state.company_location_shift_id}
                                                            placeholder="Select data capture"
                                                            isMulti
                                                            required
                                                            className={`${errors.mode_of_attendance ? " is-invalid" : ""}`}
                                                            options={DataCaptures}
                                                            value={this.state.mode_of_attendance ? this.state.mode_of_attendance.split(',').map(id => DataCaptures.find(option => option.value === id)) : null}
                                                        />
                                                        {errors.mode_of_attendance && <div className="text-danger">{errors.mode_of_attendance}</div>}
                                                    </div> */}
                                                    <div ref={this.attendance_month_cycleRef} className="col-md-6 mt-3 settings-section">
                                                        <label>Monthly Attendance Cycle</label> <br />
                                                        <div class="form-check form-check-inline mt-2">
                                                            <input
                                                                type="radio"
                                                                id="attendance_month_cycle1"
                                                                name="attendance_month_cycle1"
                                                                value='1'
                                                                checked={this.state.attendance_month_cycle === '1'}
                                                                onChange={() => this.handleRadioChange('attendance_month_cycle', '1')}
                                                                class="form-check-input"
                                                            disabled={!this.state.company_location_shift_id}
                                                            />
                                                            <label for="attendance_month_cycle1" class="form-check-label">Month start date to Month end date</label>
                                                        </div><br />
                                                        <div class="form-check form-check-inline">
                                                            <input
                                                                type="radio"
                                                                id="attendance_month_cycle2"
                                                                name="attendance_month_cycle2"
                                                                value="2"
                                                                checked={this.state.attendance_month_cycle === '2'}
                                                                onChange={() => this.handleRadioChange('attendance_month_cycle', '2')}
                                                                class="form-check-input"
                                                            disabled={!this.state.company_location_shift_id}
                                                            />
                                                            <label for="attendance_month_cycle2" class="form-check-label">Select Custome Date</label>
                                                        </div><br />
                                                        {this.state.attendance_month_cycle === "2" && (
                                                            <div className='mx-4'>
                                                                <label>Monthly Attendance Cycle Date <span className='text-muted small'>(Max from date limit is 28)</span></label>
                                                                <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: "0.5rem" }}>
                                                                    <div>
                                                                        <label>From Date</label><br />
                                                                        <Select
                                                                            onChange={(selectedOption) => { this.handleMonthCycleDate("attendance_month_cycle_from_date", selectedOption?.label) }}
                                                                            isDisabled={!this.state.company_location_shift_id}
                                                                            placeholder="Select From Date"
                                                                            required
                                                                            className={``}
                                                                            options={monthStartDates}
                                                                            value={this.state.attendance_month_cycle_from_date ? monthStartDates?.find(row => row?.label === this.state.attendance_month_cycle_from_date) : null}
                                                                        />
                                                                        
                                                                        {/* <input
                                                                            type="text"
                                                                            className={`form-control col-md-3 ${errors.attendance_month_cycle_from_date ? 'is-invalid' : ''}`}
                                                                            // disabled={!this.state.company_location_shift_id}
                                                                            name="attendance_month_cycle_from_date"
                                                                            value={this.state.attendance_month_cycle_from_date}
                                                                            placeholder="Enter From Date"
                                                                            onChange={(e) => this.handleNumberChange(e, 28)}
                                                                            required
                                                                        /> */}
                                                                    </div>

                                                                    {/* <div>
                                                                        <label>To Date</label><br />
                                                                        <Select
                                                                            onChange={(selectedOption) => { this.handleMonthCycleDate("attendance_month_cycle_to_date", selectedOption?.label) }}
                                                                            // isDisabled={!this.state.company_location_shift_id}
                                                                            placeholder="Select To Date"
                                                                            required
                                                                            className={``}
                                                                            options={monthStartDates}
                                                                            value={this.state.attendance_month_cycle_to_date ? monthStartDates?.find(row => row?.label === this.state.attendance_month_cycle_to_date) : null}
                                                                        />
                                                                    </div> */}
                                                                    <div>
                                                                        <label>To Date</label><br />
                                                                        <input
                                                                            type="text"
                                                                            className={`form-control col-md-3 ${errors.attendance_month_cycle_to_date ? 'is-invalid' : ''}`}
                                                                            // disabled={!this.state.company_location_shift_id}
                                                                            name="attendance_month_cycle_to_date"
                                                                            value={this.state.attendance_month_cycle_to_date}
                                                                            placeholder="To Date"
                                                                            onChange={(e) => this.handleNumberChange(e, 28)}
                                                                            disabled
                                                                        />
                                                                    </div>
                                                                    {errors.attendance_month_cycle_from_date || errors.attendance_month_cycle_to_date && <div className="text-danger">{errors.attendance_month_cycle_from_date || errors.attendance_month_cycle_to_date}</div>}

                                                                </div>
                                                            </div>
                                                        )}
                                                        {errors.attendance_month_cycle && <div className="text-danger mx-3">{errors.attendance_month_cycle}</div>}
                                                    </div>
                                                    {/*flexible shift. */}
                                                    <div className={`row m-auto ${this.state.is_flexi_shift == '1' && 'bg-light mt-2 pb-3 rounded-2'}`}>
                                                        {/* Is this flexible shift. */}
                                                        <div class="col-md-6 mt-3 settings-section">
                                                            <div><label class="form-label">Is this flexible shift.</label></div>
                                                            <div class="form-check form-check-inline mt-2">
                                                                <input
                                                                    type="radio"
                                                                    id="is_flexi_shift1"
                                                                    name="is_flexi_shift"
                                                                    value={1}
                                                                    checked={this.state.is_flexi_shift == '1'}
                                                                    onChange={() => this.handleRadioChange('is_flexi_shift', '1')}
                                                                    class="form-check-input"
                                                                disabled={!this.state.company_location_shift_id}
                                                                />
                                                                <label htmlFor="is_flexi_shift1" class="form-check-label">Yes</label>
                                                            </div>
                                                            <div class="form-check form-check-inline">
                                                                <input
                                                                    type="radio"
                                                                    id="is_flexi_shift0"
                                                                    name="is_flexi_shift"
                                                                    value={0}
                                                                    checked={this.state.is_flexi_shift == '0'}
                                                                    onChange={() => this.handleRadioChange('is_flexi_shift', '0')}
                                                                    class="form-check-input"
                                                                disabled={!this.state.company_location_shift_id}
                                                                />
                                                                <label htmlFor="is_flexi_shift0" class="form-check-label">No</label>
                                                            </div>
                                                            {errors.is_flexi_shift && <div className="text-danger mx-3">{errors.is_flexi_shift}</div>}
                                                        </div>
                                                        {/* Minimum hours for half day */}
                                                        {this.state.is_flexi_shift == '1' && (
                                                            <div className={`${(this.state.flexi_shift_what_to_consider_extra_hour_in_day=="1" || this.state.flexi_shift_what_to_consider_extra_hour_in_day=="2") ? 'col-md-3' : 'col-md-3'}  mt-3 settings-section`}>
                                                                <label>Minimum hours for half day
                                                                    <span className="ms-1">
                                                                        <TooltipComponent 
                                                                        name="e.g., 4.30 = 4 hours 30 minutes, 4 = 4 hours"                                                                     
                                                                        position="top"
                                                                        >
                                                                        <i 
                                                                        className="ri-information-line" 
                                                                        style={{ cursor: "pointer", color: "#007bff" }} 
                                                                        aria-label="More info"
                                                                        ></i>
                                                                        </TooltipComponent>
                                                                    </span>
                                                                </label>
                                                                <input
                                                                type="text"
                                                                className={`form-control ${errors.flexi_shift_min_hour_for_half_day ? 'is-invalid' : ''}`}
                                                                disabled={!this.state.company_location_shift_id}
                                                                name="flexi_shift_min_hour_for_half_day"
                                                                value={this.state.flexi_shift_min_hour_for_half_day}
                                                                placeholder="Enter hours and minutes"
                                                                onChange={this.handleNumberWithDotChange}
                                                                />
                                                                {errors.flexi_shift_min_hour_for_half_day && <div className="text-danger mx-3">{errors.flexi_shift_min_hour_for_half_day}</div>}
                                                            </div>
                                                        )}
                                                        {/* Minimum hours for full day */}
                                                        {this.state.is_flexi_shift == '1' && (
                                                            <div className={`${(this.state.flexi_shift_what_to_consider_extra_hour_in_day=="1" || this.state.flexi_shift_what_to_consider_extra_hour_in_day=="2") ? 'col-md-3' : 'col-md-3'} mt-3 settings-section`}>
                                                                <label>Minimum hours for full day
                                                                    <span className="ms-1">
                                                                        <TooltipComponent 
                                                                        name="e.g., 4.30 = 4 hours 30 minutes, 4 = 4 hours"                                                                     
                                                                        position="top"
                                                                        >
                                                                        <i 
                                                                        className="ri-information-line" 
                                                                        style={{ cursor: "pointer", color: "#007bff" }} 
                                                                        aria-label="More info"
                                                                        ></i>
                                                                        </TooltipComponent>
                                                                    </span>
                                                                </label>
                                                                <input
                                                                type="text"
                                                                className={`form-control ${errors.flexi_shift_min_hour_for_full_day  ? 'is-invalid' : ''}`}
                                                                disabled={!this.state.company_location_shift_id}
                                                                name="flexi_shift_min_hour_for_full_day"
                                                                value={this.state.flexi_shift_min_hour_for_full_day }
                                                                placeholder="Enter hours and minutes"
                                                                onChange={this.handleNumberWithDotChange}
                                                                />
                                                                {errors.flexi_shift_min_hour_for_full_day && <div className="text-danger mx-3">{errors.flexi_shift_min_hour_for_full_day }</div>}
                                                            </div>
                                                        )}
                                                        {/* What should consider to extra hours of a day? */}
                                                        {this.state.is_flexi_shift == '1' && (
                                                            <div className="col-md-6 mt-3 settings-section">
                                                                <div><label>What should consider to extra hours of a day?</label></div>
                                                                {/* <div className="mx-4"> */}
                                                                <div className="form-check form-check-inline">
                                                                    <input
                                                                        type="radio"
                                                                        id="flexi_shift_what_to_consider_extra_hour_in_day3"
                                                                        name="flexi_shift_what_to_consider_extra_hour_in_day"
                                                                        value="3"
                                                                        checked={this.state.flexi_shift_what_to_consider_extra_hour_in_day == "3"}
                                                                        onChange={(e) => this.handleInputChange(e)}
                                                                        className="form-check-input"
                                                                    />
                                                                    <label htmlFor="flexi_shift_what_to_consider_extra_hour_in_day3" className="form-check-label">No Action</label>
                                                                </div>
                                                                <div className="form-check form-check-inline">
                                                                    <input
                                                                        type="radio"
                                                                        id="flexi_shift_what_to_consider_extra_hour_in_day1"
                                                                        name="flexi_shift_what_to_consider_extra_hour_in_day"
                                                                        value="1"
                                                                        checked={this.state.flexi_shift_what_to_consider_extra_hour_in_day == "1"}
                                                                        onChange={(e) => this.handleInputChange(e)}
                                                                        className="form-check-input"
                                                                        
                                                                    />
                                                                    <label htmlFor="flexi_shift_what_to_consider_extra_hour_in_day1" className="form-check-label">Over Time</label>
                                                                </div>
                                                                {/* <div className="form-check form-check-inline">
                                                                    <input
                                                                        type="radio"
                                                                        id="flexi_shift_what_to_consider_extra_hour_in_day2"
                                                                        name="flexi_shift_what_to_consider_extra_hour_in_day"
                                                                        value="2"
                                                                        checked={this.state.flexi_shift_what_to_consider_extra_hour_in_day == "2"}
                                                                        onChange={(e) => this.handleInputChange(e)}
                                                                        className="form-check-input"
                                                                    />
                                                                    <label htmlFor="flexi_shift_what_to_consider_extra_hour_in_day2" className="form-check-label">Next Day Attendance</label>
                                                                </div> */}
                                                                {/* </div> */}
                                                                {errors.flexi_shift_what_to_consider_extra_hour_in_day && <div className="text-danger mx-3">{errors.flexi_shift_what_to_consider_extra_hour_in_day }</div>}
                                                            </div>
                                                        )}
                                                        {/* After how many hours for a day should consider next day or over time? */}
                                                        {this.state.is_flexi_shift == '1' && (this.state.flexi_shift_what_to_consider_extra_hour_in_day=="1" || this.state.flexi_shift_what_to_consider_extra_hour_in_day=="2") && (
                                                            <div className="col-md-6 mt-3 settings-section">
                                                                <label>After how many hours for a day should consider next day or over time?
                                                                    <span className="ms-1">
                                                                        <TooltipComponent 
                                                                        name="e.g., 4.30 = 4 hours 30 minutes, 4 = 4 hours"                                                                     
                                                                        position="top"
                                                                        >
                                                                        <i 
                                                                        className="ri-information-line" 
                                                                        style={{ cursor: "pointer", color: "#007bff" }} 
                                                                        aria-label="More info"
                                                                        ></i>
                                                                        </TooltipComponent>
                                                                    </span>
                                                                </label>
                                                                <input
                                                                type="text"
                                                                className={`form-control ${errors.flexi_shift_max_hour_for_day  ? 'is-invalid' : ''}`}
                                                                disabled={!this.state.company_location_shift_id}
                                                                name="flexi_shift_max_hour_for_day"
                                                                value={this.state.flexi_shift_max_hour_for_day }
                                                                placeholder="Enter hours and minutes"
                                                                onChange={this.handleNumberWithDotChange}
                                                                />
                                                                {errors.flexi_shift_max_hour_for_day && <div className="text-danger mx-3">{errors.flexi_shift_max_hour_for_day }</div>}
                                                            </div>
                                                        )}
                                                    </div>
                                                    {/* Minimum Hours to Be Considered for a Half Day In Hour & Minutes (E.g. 4.30) */}
                                                    {this.state.is_flexi_shift != "1" && (
                                                        <div className="col-md-6 mt-3 settings-section">
                                                            <label>Minimum Hours to Be Considered for a Half Day In Hour & Minutes.
                                                                <span className="ms-1">
                                                                    <TooltipComponent 
                                                                    name="e.g., 4.30 = 4 hours 30 minutes, 4 = 4 hours"                                                                     
                                                                    position="top"
                                                                    >
                                                                    <i 
                                                                    className="ri-information-line" 
                                                                    style={{ cursor: "pointer", color: "#007bff" }} 
                                                                    aria-label="More info"
                                                                    ></i>
                                                                    </TooltipComponent>
                                                                </span>
                                                            </label>
                                                            <input
                                                                type="text"
                                                                className={`form-control ${errors.minimum_hours_for_half_day ? 'is-invalid' : ''}`}
                                                                disabled={!this.state.company_location_shift_id}
                                                                name="minimum_hours_for_half_day"
                                                                value={this.state.minimum_hours_for_half_day}
                                                                placeholder="Enter minimum hours and minutes"
                                                                onChange={this.handleNumberWithDotChange}
                                                            />
                                                            {errors.minimum_hours_for_half_day && <div className="text-danger">{errors.minimum_hours_for_half_day}</div>}
                                                        </div>
                                                    )}
                                                    <div ref={this.multiple_punch_allowedRef} class="col-md-6 mt-3 settings-section">
                                                        <div>
                                                            <label class="form-label">Is site visit punches are allowed for this type of shift.
                                                            <span className="ms-1">
                                                                <TooltipComponent 
                                                                name="If you want multiple punch-ins and punch-outs for this shift."                                                                     
                                                                position="top"
                                                                >
                                                                <i 
                                                                className="ri-information-line" 
                                                                style={{ cursor: "pointer", color: "#007bff" }} 
                                                                aria-label="More info"
                                                                ></i>
                                                                </TooltipComponent>
                                                            </span>  
                                                            </label>
                                                        </div>
                                                        <div class="form-check form-check-inline mt-2">
                                                            <input
                                                                type="radio"
                                                                id="multiple_punch_allowed1"
                                                                name="multiple_punch_allowed"
                                                                value='1'
                                                                checked={this.state.multiple_punch_allowed == '1'}
                                                                onChange={() => this.handleRadioChange('multiple_punch_allowed', '1')}
                                                                class="form-check-input"
                                                            disabled={!this.state.company_location_shift_id}
                                                            />
                                                            <label htmlFor="multiple_punch_allowed1" class="form-check-label">Yes</label>
                                                        </div>
                                                        <div class="form-check form-check-inline">
                                                            <input
                                                                type="radio"
                                                                id="multiple_punch_allowed0"
                                                                name="multiple_punch_allowed"
                                                                value="0"
                                                                checked={this.state.multiple_punch_allowed == '0'}
                                                                onChange={() => this.handleRadioChange('multiple_punch_allowed', '0')}
                                                                class="form-check-input"
                                                            disabled={!this.state.company_location_shift_id}
                                                            />
                                                            <label htmlFor="multiple_punch_allowed0" class="form-check-label">No</label>
                                                        </div>
                                                        {this.state.multiple_punch_allowed === '1' && (
                                                            <div className='row' >
                                                                <div ref={this.allowed_punch_per_dayRef} className="col-md-6 mt-3 settings-section">
                                                                    <label>Visits allowed per day <span className='text-muted small'>(max limit 5)</span>
                                                                    <TooltipComponent 
                                                                        name="One visit includes both visit-in and visit-out."                                                                     
                                                                        position="top"
                                                                        >
                                                                        <i 
                                                                        className="ri-information-line" 
                                                                        style={{ cursor: "pointer", color: "#007bff" }} 
                                                                        aria-label="More info"
                                                                ></i>
                                                                </TooltipComponent>
                                                                    </label>
                                                                    <input
                                                                        type="text"
                                                                        className={`form-control ${errors.allowed_punch_per_day ? 'is-invalid' : ''}`}
                                                                        disabled={!this.state.company_location_shift_id}
                                                                        name="allowed_punch_per_day"
                                                                        value={this.state.allowed_punch_per_day}
                                                                        placeholder="Enter Number"
                                                                        onChange={this.handleNumberOnlyChange} />
                                                                    {errors.allowed_punch_per_day && <div className="text-danger">{errors.allowed_punch_per_day}</div>}
                                                                </div>
                                                                <div ref={this.how_multi_punch_recordRef} className="col-md-6 mt-3 settings-section">
                                                                    <label>Visit Capture Type</label>
                                                                    <Select
                                                                        value={this.state.how_multi_punch_record ? multi_punch_record_options.find(option => option.value == this.state.how_multi_punch_record) : null}
                                                                        onChange={(selectedOption) => this.handleSelectChangeOptions('how_multi_punch_record', selectedOption)}
                                                                        options={multi_punch_record_options}
                                                                        placeholder="Select capture type"
                                                                    />
                                                                    {errors.how_multi_punch_record && <div className="text-danger">{errors.how_multi_punch_record}</div>}
                                                                </div>
                                                            </div>
                                                        )}
                                                        {errors.multiple_punch_allowed && <div className="text-danger">{errors.multiple_punch_allowed}</div>}
                                                    </div>
                                                    {/* {this.state.multiple_punch_allowed === '1' && (
                                                        
                                                    )} */}
                                                    {/* <div className="col-md-6 mt-3 settings-section">
                                                        <div className="form-check form-check-inline mt-2">
                                                            <input
                                                                type="checkbox"
                                                                id="location_restriction"
                                                                name="location_restriction"
                                                                value="1"
                                                                checked={this.state.location_restriction == '1'}
                                                                onChange={(e) => this.setState({ location_restriction: e.target.checked ? 1 : 0 })}
                                                                className="form-check-input"
                                                            disabled={!this.state.company_location_shift_id}
                                                            />
                                                            <label htmlFor="location_restriction" className="form-check-label">Restrict Location for Mobile/Web Check-In/Check-Out</label>
                                                        </div>
                                                        {this.state.location_restriction == '1' && (
                                                            <div className='mx-4 mt-2'>
                                                                <label htmlFor="location_distance_restriction" className="form-check-label">Distance in Meters</label>
                                                                <input className={`form-control ${errors.location_distance_restriction ? 'is-invalid' : ''}`} value={this.state.location_distance_restriction} onChange={(e) => this.setState({ location_distance_restriction: e.target.value })} type="number" placeholder="Enter distance in meters" />
                                                                {errors.location_distance_restriction && <div className="text-danger">{errors.location_distance_restriction}</div>}
                                                            </div>
                                                        )}
                                                    </div> */}
                                                    {this.state.is_flexi_shift != "1" && (
                                                        <div ref={this.clear_late_early_marksRef} class="col-md-6 mt-3 settings-section">
                                                            <div>
                                                                <label for="clear_late_early_marks" class="form-label">Would you like to clear the late mark or early mark,if an employee has completed the certain number of hours in a day.
                                                                </label>
                                                            </div>
                                                            <div class="form-check form-check-inline mt-2">
                                                                <input
                                                                    type="radio"
                                                                    id="clear_late_early_marks1"
                                                                    name="clear_late_early_marks"
                                                                    value='1'
                                                                    checked={this.state.clear_late_early_marks == '1'}
                                                                    onChange={() => this.handleRadioChange('clear_late_early_marks', '1')}
                                                                    class="form-check-input"
                                                                disabled={!this.state.company_location_shift_id || this.state.is_flexi_shift=="1"}
                                                                />
                                                                <label for="clear_late_early_marks1" class="form-check-label">Yes</label>
                                                            </div>
                                                            <div class="form-check form-check-inline">
                                                                <input
                                                                    type="radio"
                                                                    id="clear_late_early_marks0"
                                                                    name="clear_late_early_marks"
                                                                    value="0"
                                                                    checked={this.state.clear_late_early_marks == '0'}
                                                                    onChange={() => this.handleRadioChange('clear_late_early_marks', '0')}
                                                                    class="form-check-input"
                                                                disabled={!this.state.company_location_shift_id || this.state.is_flexi_shift=="1"}
                                                                />
                                                                <label for="clear_late_early_marks0" class="form-check-label">No</label>
                                                            </div>
                                                            {this.state.clear_late_early_marks !== '0' && (
                                                                <div ref={this.clear_late_early_marks_timeRef} className="col-md-12 mt-3 settings-section">
                                                                    {/* <label>Minimum Hours to Be Considered for a Half Day In Hour & Minutes (E.g. 4.30)</label> */}
                                                                    <input
                                                                        type="text"
                                                                        className={`form-control ${errors.clear_late_early_marks ? 'is-invalid' : ''}`}
                                                                        disabled={!this.state.company_location_shift_id}
                                                                        name="clear_late_early_marks_time"
                                                                        value={this.state.clear_late_early_marks_time}
                                                                        placeholder="Enter minimum hours and minutes"
                                                                        onChange={this.handleNumberWithDotChange} />
                                                                    {errors.clear_late_early_marks_time && <div className="text-danger">{errors.clear_late_early_marks_time}</div>}
                                                                </div>
                                                            )}
                                                            {errors.clear_late_early_marks && <div className="text-danger">{errors.clear_late_early_marks}</div>}
                                                        </div>
                                                    )}
                                                    <div className="col-md-6 mt-3 settings-section">
                                                        <div><label className="form-label">Restrict employee attendance punch in & out with Geo Fencin</label></div>
                                                        <div className="form-check form-check-inline mt-2">
                                                            <input
                                                                type="radio"
                                                                id="restrict_longitude_latitude1"
                                                                name="restrict_longitude_latitude"
                                                                value="1"
                                                                checked={this.state.restrict_longitude_latitude === '1'}
                                                                onChange={() => this.handleRadioChange('restrict_longitude_latitude', '1')}
                                                                className="form-check-input"
                                                                disabled={!this.state.company_location_shift_id}
                                                            />
                                                            <label htmlFor="restrict_longitude_latitude1" className="form-check-label">Yes</label>
                                                        </div>
                                                        <div className="form-check form-check-inline">
                                                            <input
                                                                type="radio"
                                                                id="restrict_longitude_latitude0"
                                                                name="restrict_longitude_latitude"
                                                                value="0"
                                                                checked={this.state.restrict_longitude_latitude === '0'}
                                                                onChange={() => this.handleRadioChange('restrict_longitude_latitude', '0')}
                                                                className="form-check-input"
                                                                disabled={!this.state.company_location_shift_id}
                                                            />
                                                            <label htmlFor="restrict_longitude_latitude0" className="form-check-label">No</label>
                                                        </div>
                                                        {this.state.restrict_longitude_latitude === '1' && (
                                                            <div className="mt-2 settings-section">
                                                                <label className="form-label">
                                                                    Enter Your Office Location Latitude, Longitude, and Distance
                                                                </label>

                                                                <div className="row">
                                                                    <div className="col-md-6 settings-section">
                                                                        <label>Latitude</label>
                                                                        <input
                                                                            type="text"
                                                                            className={`form-control ${this.state.errors.latitude ? 'is-invalid' : ''}`}
                                                                            disabled={!this.state.company_location_shift_id}
                                                                            name="latitude"
                                                                            value={this.state.latitude}
                                                                            placeholder="Enter Latitude"
                                                                            onChange={this.handleNumberDecimalMinusOnlyChange}
                                                                        />
                                                                        {this.state.errors.latitude && <div className="text-danger">{this.state.errors.latitude}</div>}
                                                                    </div>

                                                                    <div className="col-md-6 settings-section">
                                                                        <label>Longitude</label>
                                                                        <input
                                                                            type="text"
                                                                            className={`form-control ${this.state.errors.longitude ? 'is-invalid' : ''}`}
                                                                            disabled={!this.state.company_location_shift_id}
                                                                            name="longitude"
                                                                            value={this.state.longitude}
                                                                            placeholder="Enter Longitude"
                                                                            onChange={this.handleNumberDecimalMinusOnlyChange}
                                                                        />
                                                                        {this.state.errors.longitude && <div className="text-danger">{this.state.errors.longitude}</div>}
                                                                    </div>

                                                                    <div className="col-md-6 settings-section">
                                                                        <label>Allowed distance (In Meters)</label>
                                                                        <input
                                                                            type="number"
                                                                            className={`form-control ${this.state.errors.distance ? 'is-invalid' : ''}`}
                                                                            disabled={!this.state.company_location_shift_id}
                                                                            name="distance"
                                                                            value={this.state.distance}
                                                                            placeholder="Enter Distance"
                                                                            onChange={this.handleDistanceChange}
                                                                        />
                                                                        {this.state.errors.distance && <div className="text-danger">{this.state.errors.distance}</div>}
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        )}
                                                    </div>

                                                    <div className="col-md-6 mt-4 settings-section">
                                                        <div className="form-check form-check-inline mt-2">
                                                            <input
                                                                type="checkbox"
                                                                id="exclude_holiday"
                                                                name="exclude_holiday"
                                                                value="1"
                                                                checked={this.state.exclude_holiday != '0'}
                                                                onChange={(e) => this.handleRadioChange('exclude_holiday', `${e.target.checked ? 1 : 0}`)}
                                                                className="form-check-input"
                                                            disabled={!this.state.company_location_shift_id}
                                                            />
                                                            <label htmlFor="exclude_holiday" className="form-check-label">Exclude Fixed Holidays from Continuous LOP Days</label>
                                                        </div>
                                                        {this.state.exclude_holiday != '0' && (
                                                            <div className='mx-4'>
                                                                <div className="form-check form-check-inline small">
                                                                    <input
                                                                        type="radio"
                                                                        id="exclude_holiday1"
                                                                        name="exclude_holiday"
                                                                        value="1"
                                                                        checked={this.state.exclude_holiday == '1'}
                                                                        onChange={() => this.handleRadioChange('exclude_holiday', '1')}
                                                                        className="form-check-input"
                                                                        disabled={!this.state.company_location_shift_id}
                                                                    />
                                                                    <label htmlFor="exclude_holiday1" className="form-check-label">If LOP is followed by Holiday then consider Holiday as LOP
                                                                    <span className="ms-1">
                                                                    <TooltipComponent 
                                                                    name="If an employee is marked absent (LOP) on a day, and the next day is a holiday, then that holiday will also be treated as an absent day (LOP)."                                                                     
                                                                    position="top"
                                                                    >
                                                                    <i 
                                                                    className="ri-information-line" 
                                                                    style={{ cursor: "pointer", color: "#007bff" }} 
                                                                    aria-label="More info"
                                                                    ></i>
                                                                    </TooltipComponent>
                                                                    </span>
                                                                        
                                                                    </label>
                                                                </div> <br />
                                                                <div className="form-check form-check-inline small">
                                                                    <input
                                                                        type="radio"
                                                                        id="exclude_holiday2"
                                                                        name="exclude_holiday"
                                                                        value="2"
                                                                        checked={this.state.exclude_holiday == '2'}
                                                                        onChange={() => this.handleRadioChange('exclude_holiday', '2')}
                                                                        className="form-check-input"
                                                                        disabled={!this.state.company_location_shift_id}
                                                                    />
                                                                    <label htmlFor="exclude_holiday2" className="form-check-label">If Holiday is followed by LOP then consider Holiday as LOP
                                                                    <span className="ms-1">
                                                                        <TooltipComponent 
                                                                        name="If a holiday comes before an absent day (LOP), then the holiday will also be treated as an absent day (LOP)."                                                                     
                                                                        position="top"
                                                                        >
                                                                        <i 
                                                                        className="ri-information-line" 
                                                                        style={{ cursor: "pointer", color: "#007bff" }} 
                                                                        aria-label="More info"
                                                                        ></i>
                                                                         </TooltipComponent>
                                                                                </span>
                                                                    </label>
                                                                </div>
                                                                <div className="form-check form-check-inline small">
                                                                    <input
                                                                        type="radio"
                                                                        id="exclude_holiday3"
                                                                        name="exclude_holiday"
                                                                        value="3"
                                                                        checked={this.state.exclude_holiday == '3'}
                                                                        onChange={() => this.handleRadioChange('exclude_holiday', '3')}
                                                                        className="form-check-input"
                                                                        disabled={!this.state.company_location_shift_id}
                                                                    />
                                                                    <label htmlFor="exclude_holiday3" className="form-check-label">If Holiday is between continuous LOP then consider Holiday as LOP
                                                                    <span className="ms-1">
                                                                    <TooltipComponent 
                                                                    name="If a holiday falls between two absent days (LOP), then the holiday will also be treated as an absent day (LOP)."                                                                     
                                                                     position="top"
                                                                    >
                                                                    <i 
                                                                    className="ri-information-line" 
                                                                    style={{ cursor: "pointer", color: "#007bff" }} 
                                                                    aria-label="More info"
                                                                    ></i>
                                                                    </TooltipComponent>
                                                                    </span>
                                                                    </label>
                                                                </div>
                                                            </div>
                                                        )}
                                                    </div>
                                                    <div className="col-md-6 mt-4 settings-section">
                                                        <div className="form-check form-check-inline mt-2">
                                                            <input
                                                                type="checkbox"
                                                                id="exclude_weekly_off"
                                                                name="exclude_weekly_off"
                                                                value="1"
                                                                checked={this.state.exclude_weekly_off != '0'}
                                                                onChange={(e) => this.handleRadioChange('exclude_weekly_off', `${e.target.checked ? 1 : 0}`)}
                                                                className="form-check-input"
                                                            disabled={!this.state.company_location_shift_id}
                                                            />
                                                            <label htmlFor="exclude_weekly_off" className="form-check-label">Exclude Fixed WeeklyOff from Continuous LOP Days</label>
                                                        </div>
                                                        {this.state.exclude_weekly_off != '0' && (
                                                            <div className='mx-4'>
                                                                <div className="form-check form-check-inline small">
                                                                    <input
                                                                        type="radio"
                                                                        id="exclude_weekly_off1"
                                                                        name="exclude_weekly_off"
                                                                        value="1"
                                                                        checked={this.state.exclude_weekly_off == '1'}
                                                                        onChange={() => this.handleRadioChange('exclude_weekly_off', '1')}
                                                                        className="form-check-input"
                                                                        disabled={!this.state.company_location_shift_id}
                                                                    />
                                                                    <label htmlFor="exclude_weekly_off1" className="form-check-label">If LOP is followed by WeeklyOff then consider WeeklyOff as LOP
                                                                    <span className="ms-1">
                                                                    <TooltipComponent 
                                                                    name="If an absent day (LOP) comes before a weekly off, the weekly off will also be marked as absent (LOP)."                                                                     
                                                                    position="top"
                                                                    >
                                                                    <i 
                                                                    className="ri-information-line" 
                                                                    style={{ cursor: "pointer", color: "#007bff" }} 
                                                                    aria-label="More info"
                                                                    ></i>
                                                                    </TooltipComponent>
                                                                    </span>
                                                                        
                                                                    </label>
                                                                </div> <br />
                                                                <div className="form-check form-check-inline small">
                                                                    <input
                                                                        type="radio"
                                                                        id="exclude_weekly_off2"
                                                                        name="exclude_weekly_off"
                                                                        value="2"
                                                                        checked={this.state.exclude_weekly_off == '2'}
                                                                        onChange={() => this.handleRadioChange('exclude_weekly_off', '2')}
                                                                        className="form-check-input"
                                                                        disabled={!this.state.company_location_shift_id}
                                                                    />
                                                                    <label htmlFor="exclude_weekly_off2" className="form-check-label">If WeeklyOff is followed by LOP then consider WeeklyOff as LOP
                                                                    <span className="ms-1">
                                                                        <TooltipComponent 
                                                                        name="If a weekly off comes before an absent day (LOP), the weekly off will also be marked as absent (LOP).."                                                                     
                                                                        position="top"
                                                                        >
                                                                        <i 
                                                                        className="ri-information-line" 
                                                                        style={{ cursor: "pointer", color: "#007bff" }} 
                                                                        aria-label="More info"
                                                                        ></i>
                                                                         </TooltipComponent>
                                                                                </span>
                                                                    </label>
                                                                </div>
                                                                <div className="form-check form-check-inline small">
                                                                    <input
                                                                        type="radio"
                                                                        id="exclude_weekly_off3"
                                                                        name="exclude_weekly_off"
                                                                        value="3"
                                                                        checked={this.state.exclude_weekly_off == '3'}
                                                                        onChange={() => this.handleRadioChange('exclude_weekly_off', '3')}
                                                                        className="form-check-input"
                                                                        disabled={!this.state.company_location_shift_id}
                                                                    />
                                                                    <label htmlFor="exclude_weekly_off3" className="form-check-label">If WeeklyOff is between continuous LOP then consider WeeklyOff as LOP
                                                                    <span className="ms-1">
                                                                    <TooltipComponent 
                                                                    name="If a weekly off falls between two absent days (LOP), then it will also be treated as absent (LOP).."                                                                     
                                                                     position="top"
                                                                    >
                                                                    <i 
                                                                    className="ri-information-line" 
                                                                    style={{ cursor: "pointer", color: "#007bff" }} 
                                                                    aria-label="More info"
                                                                    ></i>
                                                                    </TooltipComponent>
                                                                    </span>
                                                                    </label>
                                                                </div>
                                                            </div>
                                                        )}
                                                    </div>
                                                   
                                                    {this.state.is_flexi_shift != "1" && (
                                                        <div class="row mt-4 mb-4">
                                                            <div class="col-md-6">
                                                                <h5 class="card-header">Late Coming Policies</h5>
                                                                <div class="row">
                                                                    <div class="col-md-12 mt-3 settings-section">
                                                                        <div>
                                                                            <label for="auto_regularize_checkin" class="form-label">Auto regularize check in time as per the shift timings
                                                                            <span className="ms-1">
                                                                                <TooltipComponent 
                                                                                name="The check-in time will be recorded as per the shift timing, even if the employee come late"                                                                     
                                                                                position="top"
                                                                                >
                                                                                <i 
                                                                                className="ri-information-line" 
                                                                                style={{ cursor: "pointer", color: "#007bff" }} 
                                                                                aria-label="More info"
                                                                                ></i>
                                                                                </TooltipComponent>
                                                                            </span>
                                                                            </label>
                                                                        </div>
                                                                        <div class="form-check form-check-inline mt-2">
                                                                            <input
                                                                                type="radio"
                                                                                id="auto_regularize_checkin1"
                                                                                name="auto_regularize_checkin"
                                                                                value="1"
                                                                                checked={this.state.auto_regularize_checkin == '1'}
                                                                                onChange={() => this.handleRadioChange('auto_regularize_checkin', '1')}
                                                                                class="form-check-input"
                                                                            disabled={!this.state.company_location_shift_id || this.state.is_flexi_shift=="1"}
                                                                            />
                                                                            <label for="auto_regularize_checkin1" class="form-check-label">Yes</label>
                                                                        </div>
                                                                        <div class="form-check form-check-inline">
                                                                            <input
                                                                                type="radio"    
                                                                                id="auto_regularize_checkin0"
                                                                                name="auto_regularize_checkin"
                                                                                value="0"
                                                                                checked={this.state.auto_regularize_checkin == '0'}
                                                                                onChange={() => this.handleRadioChange('auto_regularize_checkin', '0')}
                                                                                class="form-check-input"
                                                                            disabled={!this.state.company_location_shift_id || this.state.is_flexi_shift=="1"}
                                                                            />
                                                                            <label for="auto_regularize_checkin0" class="form-check-label">No</label>
                                                                        </div>
                                                                    </div>

                                                                    <div class="col-md-12 mt-3 settings-section">
                                                                        <label>Grace period for late coming only in minutes</label>
                                                                        <input
                                                                            type="text"
                                                                            disabled={!this.state.company_location_shift_id || this.state.is_flexi_shift=="1"}
                                                                            className={`form-control ${errors.grace_period_late ? 'is-invalid' : ''}`}
                                                                            name="grace_period_late"
                                                                            value={this.state.grace_period_late}
                                                                            placeholder="Enter grace period in minutes"
                                                                            onChange={this.handleNumberOnlyChange}
                                                                        />
                                                                        {errors.grace_period_late && <div className="text-danger">{errors.grace_period_late}</div>}
                                                                    </div>

                                                                    <div class="col-md-12 mt-3 settings-section">
                                                                        <div>
                                                                            <label for="excluded_grace_period_status_checkin" class="form-label">Do you want the Grace Period to be excluded when considering the Late Mark</label>
                                                                        </div>
                                                                        <div class="form-check form-check-inline mt-2">
                                                                            <input
                                                                                type="radio"
                                                                                id="excluded_grace_period_status_checkin1"
                                                                                name="excluded_grace_period_status_checkin"
                                                                                value="1"
                                                                                checked={this.state.excluded_grace_period_status_checkin == '1'}
                                                                                onChange={() => this.handleRadioChange('excluded_grace_period_status_checkin', '1')}
                                                                                class="form-check-input"
                                                                            disabled={!this.state.company_location_shift_id || this.state.is_flexi_shift=="1"}
                                                                            />
                                                                            <label for="excluded_grace_period_status_checkin1" class="form-check-label">Yes</label>
                                                                        </div>
                                                                        <div class="form-check form-check-inline">
                                                                            <input
                                                                                type="radio"
                                                                                id="excluded_grace_period_status_checkin0"
                                                                                name="excluded_grace_period_status_checkin"
                                                                                value="0"
                                                                                checked={this.state.excluded_grace_period_status_checkin == '0'}
                                                                                onChange={() => this.handleRadioChange('excluded_grace_period_status_checkin', '0')}
                                                                                class="form-check-input"
                                                                            disabled={!this.state.company_location_shift_id || this.state.is_flexi_shift=="1"}
                                                                            />
                                                                            <label for="excluded_grace_period_status_checkin0" class="form-check-label">No</label>
                                                                        </div>
                                                                    </div>

                                                                    <div class="col-md-12 mt-3 settings-section">
                                                                        <label for="excluded_grace_period_checkin" className={`form-label`}>{this.state.excluded_grace_period_status_checkin == 1 ? 'From End of Grace Period (Number of Mins to be considered after end of Grace Period)' : 'From Start of Shift Timing (Number of Mins to be considered for Late Mark)'}</label>
                                                                        <input
                                                                            type="number"
                                                                            disabled={!this.state.company_location_shift_id || this.state.is_flexi_shift=="1"}
                                                                            className={`form-control ${errors.excluded_grace_period_checkin ? 'is-invalid' : ''}`}
                                                                            name="excluded_grace_period_checkin"
                                                                            id="excluded_grace_period_checkin"
                                                                            value={this.state.excluded_grace_period_checkin}
                                                                            placeholder="Enter minutes"
                                                                            onChange={this.handleNumberOnlyChange}
                                                                        />
                                                                        {errors.excluded_grace_period_checkin && <div className="text-danger">{errors.excluded_grace_period_checkin}</div>}
                                                                    </div>

                                                                    <div class="col-md-12 mt-3 settings-section">
                                                                        <label>How many Late Mark allowed in a month <span className='text-muted small'>(Input max limit 31 Days)</span></label>
                                                                        <input
                                                                            type="text"
                                                                            className={`form-control ${errors.late_coming_limit ? 'is-invalid' : ''}`}
                                                                            disabled={!this.state.company_location_shift_id || this.state.is_flexi_shift=="1"}
                                                                            name="late_coming_limit"
                                                                            value={this.state.late_coming_limit}
                                                                            placeholder="Enter number of late comings allowed"
                                                                            onChange={this.handleNumberOnlyTill31Change}
                                                                        />
                                                                        {errors.late_coming_limit && <div className="text-danger">{errors.late_coming_limit}</div>}
                                                                    </div>

                                                                    {/* <div class="col-md-12 mt-3 settings-section">
                                                                        <label>Late coming allowed minutes:</label>
                                                                        <input
                                                                            type="number"
                                                                            // disabled={!this.state.company_location_shift_id || this.state.is_flexi_shift=="1"}
                                                                            class="form-control"
                                                                            name="late_allowed_minutes"
                                                                            value={this.state.late_allowed_minutes}
                                                                            placeholder="Enter late allowed minutes"
                                                                            onChange={this.handleInputChange}
                                                                        />
                                                                    </div> */}

                                                                <div className="col-md-12 mt-3 settings-section">
                                                                    <label>After how many late mark will below action shall take place? <span className='text-muted small'>(Input max limit 31 Days)</span></label>
                                                                    <input
                                                                        type="text"
                                                                        className={`form-control ${errors.late_coming_exceeding_policy ? 'is-invalid' : ''}`}
                                                                        name="late_coming_exceeding_policy"
                                                                        disabled={!this.state.company_location_shift_id || this.state.is_flexi_shift=="1"}
                                                                        value={this.state.late_coming_exceeding_policy}
                                                                        placeholder="Enter In Days"
                                                                        onChange={this.handleNumberOnlyTill31Change}
                                                                    />
                                                                </div>
                                                                    
                                                                </div>
                                                                </div>

                                                            <div class="col-md-6">
                                                                <h5 class="card-header" >Early Going Policies</h5>
                                                                <div class="row">
                                                                    <div class="col-md-12 mt-3 settings-section">
                                                                        <div>
                                                                            <label for="auto_regularize_checkout" class="form-label" >Auto regularize check out time as per the shift timings
                                                                            <span className="ms-1">
                                                                                <TooltipComponent 
                                                                                name="The check-out time will be recorded as per the shift timing, even if the employee leaves early."                                                                     
                                                                                position="top"
                                                                                >
                                                                                <i 
                                                                                className="ri-information-line" 
                                                                                style={{ cursor: "pointer", color: "#007bff" }} 
                                                                                aria-label="More info"
                                                                                ></i>
                                                                                </TooltipComponent>
                                                                            </span> 
                                                                            </label>
                                                                        </div>
                                                                        <div class="form-check form-check-inline mt-2">
                                                                            <input
                                                                                type="radio"
                                                                                id="auto_regularize_checkout1"
                                                                                name="auto_regularize_checkout"
                                                                                value="1"
                                                                                checked={this.state.auto_regularize_checkout == '1'}
                                                                                onChange={() => this.handleRadioChange('auto_regularize_checkout', '1')}
                                                                                class="form-check-input"
                                                                                
                                                                            disabled={!this.state.company_location_shift_id || this.state.is_flexi_shift=="1"}
                                                                            />
                                                                            <label for="auto_regularize_checkout1" class="form-check-label">Yes</label>
                                                                        </div>
                                                                        <div class="form-check form-check-inline">
                                                                            <input
                                                                                type="radio"
                                                                                id="auto_regularize_checkout0"
                                                                                name="auto_regularize_checkout"
                                                                                value="0"
                                                                                checked={this.state.auto_regularize_checkout == '0'}
                                                                                onChange={() => this.handleRadioChange('auto_regularize_checkout', '0')}
                                                                                class="form-check-input"
                                                                            disabled={!this.state.company_location_shift_id || this.state.is_flexi_shift=="1"}
                                                                            />
                                                                            <label for="auto_regularize_checkout0" class="form-check-label">No</label>
                                                                        </div>
                                                                    </div>

                                                                    <div class="col-md-12 mt-3 settings-section">
                                                                        <label >Grace period for early going only in minutes</label>
                                                                        <input
                                                                            type="number"
                                                                            disabled={!this.state.company_location_shift_id || this.state.is_flexi_shift=="1"}
                                                                            className={`form-control ${errors.grace_period_early ? 'is-invalid' : ''}`}
                                                                            name="grace_period_early"
                                                                            value={this.state.grace_period_early}
                                                                            placeholder="Enter grace period in minutes"
                                                                            onChange={this.handleNumberOnlyChange}
                                                                            
                                                                        />
                                                                        {errors.grace_period_early && <div className="text-danger">{errors.grace_period_early}</div>}
                                                                    </div>

                                                                    <div class="col-md-12 mt-3 settings-section">
                                                                        <div>
                                                                            <label for="excluded_grace_period_status_checkout" class="form-label" >Do you want the Grace Period to be excluded when considering Early Going</label>
                                                                        </div>
                                                                        <div class="form-check form-check-inline mt-2">
                                                                            <input
                                                                                type="radio"
                                                                                id="excluded_grace_period_status_checkout1"
                                                                                name="excluded_grace_period_status_checkout"
                                                                                value="1"
                                                                                checked={this.state.excluded_grace_period_status_checkout == '1'}
                                                                                onChange={() => this.handleRadioChange('excluded_grace_period_status_checkout', '1')}
                                                                                class="form-check-input"
                                                                            disabled={!this.state.company_location_shift_id || this.state.is_flexi_shift=="1"}
                                                                            />
                                                                            <label for="excluded_grace_period_status_checkout1" class="form-check-label">Yes</label>
                                                                        </div>
                                                                        <div class="form-check form-check-inline">
                                                                            <input
                                                                                type="radio"
                                                                                id="excluded_grace_period_status_checkout0"
                                                                                name="excluded_grace_period_status_checkout"
                                                                                value="0"
                                                                                checked={this.state.excluded_grace_period_status_checkout == '0'}
                                                                                onChange={() => this.handleRadioChange('excluded_grace_period_status_checkout', '0')}
                                                                                class="form-check-input"
                                                                            disabled={!this.state.company_location_shift_id || this.state.is_flexi_shift=="1"}
                                                                            />
                                                                            <label for="excluded_grace_period_status_checkout0" class="form-check-label">No</label>
                                                                        </div>
                                                                    </div>

                                                                    <div class="col-md-12 mt-3 settings-section">
                                                                        <label for="excluded_grace_period_checkout" className={`form-label`} >{this.state.excluded_grace_period_status_checkout == 1 ?
                                                                            'Before start of Early Going Grace Period (Number of Mins to be considered for Early Mark)' : 'Before End of Shift Timing (Number of Mins to be considered for Early Mark)'}</label>
                                                                        <input
                                                                            type="text"
                                                                            disabled={!this.state.company_location_shift_id || this.state.is_flexi_shift=="1"}
                                                                            className={`form-control ${errors.excluded_grace_period_checkout ? 'is-invalid' : ''}`}
                                                                            name="excluded_grace_period_checkout"
                                                                            id="excluded_grace_period_checkout"
                                                                            value={this.state.excluded_grace_period_checkout}
                                                                            placeholder="Enter minutes"
                                                                            onChange={this.handleNumberOnlyChange}
                                                                        />
                                                                        {errors.excluded_grace_period_checkout && <div className="text-danger">{errors.excluded_grace_period_checkout}</div>}
                                                                    </div>

                                                                    <div class="col-md-12 mt-3 settings-section">
                                                                        <label >How many Early Mark allowed in a month <span className='text-muted small'>(Input max limit 31 Days)</span></label>
                                                                        <input
                                                                            type="text"
                                                                            className={`form-control ${errors.early_going_limit ? 'is-invalid' : ''}`}
                                                                            disabled={!this.state.company_location_shift_id || this.state.is_flexi_shift=="1" }
                                                                            name="early_going_limit"
                                                                            value={this.state.early_going_limit}
                                                                            placeholder="Enter number of early goings allowed"
                                                                            onChange={this.handleNumberOnlyTill31Change}
                                                                            
                                                                        />
                                                                        {errors.early_going_limit && <div className="text-danger">{errors.early_going_limit}</div>}
                                                                    </div>

                                                                    {/* <div class="col-md-12 mt-3 settings-section">
                                                                        <label>Early going allowed minutes:</label>
                                                                        <input
                                                                            type="number"
                                                                            // disabled={!this.state.company_location_shift_id || this.state.is_flexi_shift=="1"}
                                                                            class="form-control"
                                                                            name="early_going_allowed_minute"
                                                                            value={this.state.early_going_allowed_minute}
                                                                            placeholder="Enter early going allowed minutes"
                                                                            onChange={this.handleInputChange}
                                                                        />
                                                                    </div> */}

                                                                    <div class="col-md-12 mt-3 settings-section">
                                                                        <label >What if Number of Early Mark Exceeds allowed numbers in a month
                                                                        {/* <span className='text-muted small'>(Half Day LOP to be marked on every early mark occasion) </span> */}
                                                                        <span className='text-muted small'> (Input Max limit 31 Days)</span></label>
                                                                        <input
                                                                            type="text"
                                                                            className={`form-control ${errors.early_going_exceeding_policy ? 'is-invalid' : ''}`}
                                                                            name="early_going_exceeding_policy"
                                                                            disabled={!this.state.company_location_shift_id || this.state.is_flexi_shift=="1"}
                                                                            value={this.state.early_going_exceeding_policy}
                                                                            placeholder="Enter In Days"
                                                                            onChange={this.handleNumberOnlyTill31Change}
                                                                        />
                                                                        {errors.early_going_exceeding_policy && <div className="text-danger">{errors.early_going_exceeding_policy}</div>}
                                                                    </div>
                                                                </div>
                                                            </div>
                                                            <div className='col-md-12'>
                                                                <h5 class="card-header" />
                                                            <div ref={this.latemark_exceeds_allowedRef} className='col-md-6'>
                                                                <label className='mt-2'>What action should take once above condition satisfy</label>
                                                                <div className="form-check">
                                                                    <input
                                                                        type="radio"
                                                                        id="markLOP"
                                                                        name="latemarkOption"
                                                                        value="1"
                                                                        checked={this.state.latemark_exceeds_allowed === "1"}
                                                                        onChange={() => this.handleMainOptionChange("1")}
                                                                        className="form-check-input"
                                                                        disabled={!this.state.company_location_shift_id || this.state.is_flexi_shift=="1"}
                                                                    />
                                                                    <label htmlFor="markLOP" className="form-check-label">Mark LOP</label>
                                                                </div>
                                                                {this.state.latemark_exceeds_allowed === "1" && (
                                                                    <div className="mx-4">
                                                                        <div className="form-check form-check-inline">
                                                                            <input
                                                                                type="radio"
                                                                                id="halfDayLOP"
                                                                                name="latemark_exceed"
                                                                                value="2"
                                                                                checked={this.state.latemark_exceed === "2"}
                                                                                onChange={() => this.handleLOPChange("2")}
                                                                                className="form-check-input"
                                                                                disabled={!this.state.company_location_shift_id || this.state.is_flexi_shift=="1"}
                                                                                
                                                                            />
                                                                            <label htmlFor="halfDayLOP" className="form-check-label">Half Day LOP</label>
                                                                        </div>
                                                                        <div className="form-check form-check-inline">
                                                                            <input
                                                                                type="radio"
                                                                                id="fullDayLOP"
                                                                                name="latemark_exceed"
                                                                                value="1"
                                                                                checked={this.state.latemark_exceed === "1"}
                                                                                onChange={() => this.handleLOPChange("1")}
                                                                                className="form-check-input"
                                                                                disabled={!this.state.company_location_shift_id || this.state.is_flexi_shift=="1"}
                                                                            />
                                                                            <label htmlFor="fullDayLOP" className="form-check-label">Full Day LOP</label>
                                                                        </div>
                                                                    </div>
                                                                )}
                                                                <div className="form-check">
                                                                    <input
                                                                        type="radio"
                                                                        id="applyLeave"
                                                                        name="latemarkOption"
                                                                        value="2"
                                                                        checked={this.state.latemark_exceeds_allowed === "2"}
                                                                        onChange={() => this.handleMainOptionChange("2")}
                                                                        className="form-check-input"
                                                                        disabled={!this.state.company_location_shift_id || this.state.is_flexi_shift=="1" || this.state.leaveOptions.length===0}
                                                                    />
                                                                    <label htmlFor="applyLeave" className="form-check-label">
                                                                        Auto apply from the balance leave {this.state.leaveOptions.length===0 && (
                                                                            <span className='text-muted small'>(No leaves available)</span>
                                                                        )}
                                                                    </label>
                                                                </div>
                                                                {this.state.latemark_exceeds_allowed === "2" && (
                                                                    <div className="mx-4">
                                                                        <div className="form-check form-check-inline">
                                                                            <input
                                                                                type="radio"
                                                                                id="halfDayLOP"
                                                                                name="latemark_exceed"
                                                                                value="2"
                                                                                checked={this.state.latemark_exceed === "2"}
                                                                                onChange={() => this.handleLOPChange("2")}
                                                                                className="form-check-input"
                                                                                disabled={!this.state.company_location_shift_id || this.state.is_flexi_shift=="1"}
                                                                                
                                                                            />
                                                                            <label htmlFor="halfDayLOP" className="form-check-label">Half Day Leave</label>
                                                                        </div>

                                                                        <div className="form-check form-check-inline">
                                                                            <input
                                                                                type="radio"
                                                                                id="fullDayLOP"
                                                                                name="latemark_exceed"
                                                                                value="1"
                                                                                checked={this.state.latemark_exceed === "1"}
                                                                                onChange={() => this.handleLOPChange("1")}
                                                                                className="form-check-input"
                                                                                disabled={!this.state.company_location_shift_id || this.state.is_flexi_shift=="1"}
                                                                            />
                                                                            <label htmlFor="fullDayLOP" className="form-check-label">Full Day Leave</label>
                                                                        </div>
                                                                    </div>
                                                                )}
                                                                {this.state.latemark_exceeds_allowed === "2" && (
                                                                    <div className="mx-4 mt-1 settings-section">
                                                                            {this.state.absentHierarchy.length < this.state.leaveOptions.length && (
                                                                            <select
                                                                                value=""
                                                                                className="form-control"
                                                                                disabled={!this.state.company_location_shift_id || this.state.is_flexi_shift=="1"}
                                                                                onChange={(e) => this.handleHierchy(e.target.value)}
                                                                            >
                                                                                <option value="" disabled>Select hierarchy</option>
                                                                                {!this.state.loading &&
                                                                                    this.state.leaveOptions.map((option, index) =>
                                                                                        !this.state.absentHierarchy.some(item => item.leave_type_id == option.leave_type_id) ? (
                                                                                            <option key={index} value={option.leave_type_id} >{option.leave_type_name}</option>
                                                                                        ) : null
                                                                                    )}
                                                                            </select>
                                                                        )}
                                                                        {errors.absentHierarchy && <div className="text-danger">{errors.absentHierarchy}</div>}
                                                                    {/* <div className="mx-4">
                                                                        {this.state.absentHierarchy.map((leave_type_id, idx) => {
                                                                            const leave = this.state.leaveOptions.find(option => option.leave_type_id === leave_type_id);
                                                                            return leave ? (
                                                                                <small key={idx}>
                                                                                    {idx + 1}. {leave.leave_type_name} 
                                                                                    <span
                                                                                        onClick={() => this.handleRemoveAbsentHierarchy(leave_type_id)} 
                                                                                        style={{ fontSize: "1.2rem", cursor: "pointer", color: "blue", marginLeft: "8px" }}
                                                                                    >
                                                                                        x
                                                                                    </span>
                                                                                </small>
                                                                            ) : null;
                                                                        })}
                                                                    </div> */}
                                                                    
                                                                        <div className="mx-1">
                                                                            {this.state.absentHierarchy.map((val, idx) => (
                                                                                <small key={idx} className=' noWrap ms-2 border border-light rounded-3 px-2'>
                                                                                    {idx + 1}. {val?.leave_type_name}{" "}
                                                                                    <span
                                                                                        onClick={() => this.handleRemoveAbsentHierarchy(val?.leave_type_id)}
                                                                                        className='ms-1'
                                                                                        style={{ fontSize: "1.2rem", cursor: "pointer", color: "blue" }}
                                                                                    >
                                                                                        x
                                                                                    </span>
                                                                                </small>
                                                                            ))}
                                                                        </div>
                        
                                                                        

                                                                    </div>
                                                                )} 
                                                                <div className="form-check">
                                                                    <input
                                                                        type="radio"
                                                                        id="noAction"
                                                                        name="latemarkOption"
                                                                        value="3"
                                                                        checked={this.state.latemark_exceeds_allowed === "3"}
                                                                        onChange={() => this.handleMainOptionChange("3")}
                                                                        className="form-check-input"
                                                                        disabled={!this.state.company_location_shift_id || this.state.is_flexi_shift=="1"}
                                                                    />
                                                                    <label htmlFor="noAction" className="form-check-label">No Action</label>
                                                                </div>
                                                                {errors.latemark_exceed && <div className="text-danger">{errors.latemark_exceed}</div>}
                                                                {errors.latemark_exceeds_allowed && <div className="text-danger">{errors.latemark_exceeds_allowed}</div>}
                                                            </div>
                                                            </div>
                                                        </div>
                                                    )}           
                                                    {/* Submit Button */}
                                                    <div style={{ marginTop: "30px", marginLeft: 'Auto' }}>
                                                        {/* {!this.state.postLoading ?
                                                            <SubmitBtn icon="ri-save-line" text={this.state.attendance_setting_id ? "Update" : "Save"} type={`primary`} /> :
                                                            <button disabled={true}
                                                                className={`btn btn-primary btn-label waves-effect right waves-light float-right`}>
                                                                <i className={`ri-save-line label-icon align-middle fs-16 ms-2`} />{" "}
                                                                Loading...
                                                            </button>
                                                        } */}
                                                        <SubmitButton
                                                        loading={this.state.postLoading} disabled={!this.state.company_location_shift_id} 
                                                        loadingMessage='Loading' buttonName={this.state.attendance_setting_id ? "Update" : "Save"} icon={'ri-save-line'} 
                                                        type='primary' iconSide='left' />
                                                    </div>
                                                </form>
                                            </div>

                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div >
            </div >
        )
    };
}
export default withRouter(GeneralSettings);
